var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-stripes bg-gray-500 bg-stripes-gray-400 border border-black select-none px-1 md:px-2 py-1 md:py-2 flex justify-between items-center",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"font-bold w-16 md:w-24 text-center text-white"},[_vm._v(" "+_vm._s(_vm.rackNumber)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }